import { render } from "./forumContent.vue?vue&type=template&id=4e490421&scoped=true"
import script from "./forumContent.vue?vue&type=script&lang=js"
export * from "./forumContent.vue?vue&type=script&lang=js"

import "./forumContent.vue?vue&type=style&index=0&id=4e490421&scoped=true&lang=scss"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e490421"]])

export default __exports__